$(function () {

    // ----------------------------------------
    // General
    // ----------------------------------------

    // Add Tooltip to all elements with data-toggle="tooltip"


    //Move to previous or next Customer-Show
    $(document).keydown(function (event) {
        if (event.keyCode == 37) {
            $("a#lbPrev")[0].click();
        }
        if (event.keyCode == 39) {
            $("a#lbNext")[0].click();
        }
    });
    // Prevent Move when Cursor is in Input-Field
    $('input[type="text"]').keydown(function (e) {
        e.stopPropagation();
    });

    // Hide helping fileds
    $("#invisible_fields").hide();

    // Alert
    var alert = $(".alert");
    if (alert.length > 0) {
        alert.show().animate({ height: alert.outerHeight() }, 30);
        if ($("#error_explanation").length > 0) {
            // empty
        }
        else {
            window.setTimeout(function () {
                alert.slideUp();
            }, 3000);
        }
    }


    // ----------------------------------------
    // CUSTOMER-MODEL
    // ----------------------------------------

    // CUSTOMER-INDEX
    // --------------

    // CUSTOMER-SHOW
    // -------------
    // todo: (nicht ausprobiert, ob es funktioniert) Set depending Dropdown fileds
    $("#company_type_drop").change(function () {
        if (this.value == "Private") {
            $("#company_name").hide();
        }
        else {
            $("#company_name").show();
        }
    });
    $("#company_type_drop").change();

    // CUSTOMER-EDIT
    // -------------



    // ----------------------------------------
    // ORDER-MODEL
    // ----------------------------------------

    // ORDER-INDEX
    // -----------


    // ORDER-SHOW
    // ----------
    $("#delivery_type_drop").change(function () {
        if (this.value == "Handover") {
            $("#postal_info").hide();
        }
        else {
            $("#postal_info").show();
        }
    });
    $("#delivery_type_drop").change();



    // ORDER-EDIT
    // ----------
    // Show Different-Shipping-Address-Card
    $("#different_shipping_address_drop").change(function () {
        // console.log("checkbox state: " + this.value);

        if (this.value == "Nein") {
            $("#different_shipping_address").hide();
        }
        else {
            $("#different_shipping_address").show();
        }
    });
    $("#different_shipping_address_drop").change();

    // DateTimePicker
    $("#datetimepicker_order_date").datetimepicker({
        icons: {
            previous: "fa fa-arrow-left",
            next: "fa fa-arrow-right",
            today: "fa fa-calendar-check-o"
        },
        format: "DD.MM.YYYY",
        buttons: {
            showToday: true
        },
        allowInputToggle: true
    });
    $("#datetimepicker_payment_date").datetimepicker({
        icons: {
            previous: "fa fa-arrow-left",
            next: "fa fa-arrow-right",
            today: "fa fa-calendar-check-o"
        },
        format: "DD.MM.YYYY",
        buttons: {
            showToday: true
        },
        allowInputToggle: true
    });
    $("#datetimepicker_invoice_date").datetimepicker({
        icons: {
            previous: "fa fa-arrow-left",
            next: "fa fa-arrow-right",
            today: "fa fa-calendar-check-o"
        },
        format: "DD.MM.YYYY",
        buttons: {
            showToday: true
        },
        allowInputToggle: true
    });



})